import { inputObj, pickerObj } from "utils/getObjs";

const basicInformation = [
  inputObj('单位名称', 'unitName', true, true),
  inputObj('工商营业执照号码', 'businessNum', true, true),
  pickerObj('所属行业', 'industry', true),
  pickerObj('单位类型', 'type', true),
  pickerObj('经济类型', 'economicType', true),
  pickerObj('人员规模', 'person'),
  inputObj('注册资金（元）', 'regCapital'),
  pickerObj('所属地区行政区划代码', 'areaCode', true),
  inputObj('单位地址', 'address'),
  inputObj('邮政编码', 'zipCode'),
  inputObj('单位网站', 'website'),
  inputObj('单位简介', 'describe'),
  inputObj('法定代表人', 'legal'),
  inputObj('法定代表人电话', 'legalTel'),
  inputObj('联系人', 'contact', true),
  inputObj('联系电话', 'contactTel'),
  {
    infoType: 'verificationCode',
    postName: 'contactPhone',
    codePostName: 'authCode',
    label: '联系手机',
    codeLabel: '验证码',
    message: '请输入联系手机',
    codeMessage: '请输入验证码',
    required: true,
    disabled: false,
    time: 180,
  },
  inputObj('传真电话', 'fax'),
  inputObj('电子邮箱', 'email'),
  // 资料上传
  {
    ...inputObj('营业执照', 'file'.true),
    type: 'fileForm',
    key:'onlyOne'
  }
];


export const unitRegisterPage1 = [
  { title: '基本信息', arr: basicInformation },
]

